module.exports = __webpack_public_path__ + "img/ic_bulb.bc4a4ab7.svg";